"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Adds an id to a token list attribute if its not already present in the list
 */
var tokenList = function tokenList(id) {
  var currentVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var values = currentVal.split(' ');

  if (values.includes(id)) {
    return currentVal;
  }

  values.push(id);
  return values.join(' ');
};

var _default = tokenList;
exports["default"] = _default;